import type {
  Configuration,
  CreateDlsgPolicyRequest,
  DlsgSettings,
  ImportDlsgCertificateRequest,
  UpdateDlsgPolicyRequest,
} from '@repo/api-gw-sdk';
import {
  DlsgPoliciesApi,
  DlsgSettingsApi,
  StorageGatewaysApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/storage-gateway';

export const storageGateway = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const dlsgPoliciesApi = new DlsgPoliciesApi(config);
  const dlsgSettingsApi = new DlsgSettingsApi(config);
  const storageGatewaysApi = new StorageGatewaysApi(config);

  return {
    useListPolicies: () =>
      httpClient.execute(
        dlsgPoliciesApi.listDlsgPolicies.bind(dlsgPoliciesApi),
        baseUrl,
        'listDlsgPolicies',
        currentProjectId
      ),
    create: (request: CreateDlsgPolicyRequest) =>
      dlsgPoliciesApi.createDlsgPolicy(currentProjectId, request),
    update: (id: string, request: UpdateDlsgPolicyRequest) =>
      dlsgPoliciesApi.updateDlsgPolicy(currentProjectId, id, request),
    useListStorageGateways: () =>
      httpClient.execute(
        storageGatewaysApi.listStorageGateways.bind(storageGatewaysApi),
        baseUrl,
        'listStorageGateways',
        currentProjectId
      ),
    importDlsgCertificate: (request: ImportDlsgCertificateRequest) =>
      storageGatewaysApi.importDlsgCertificate(currentProjectId, request),
    useDlsgSettings: () =>
      httpClient.execute(
        dlsgSettingsApi.getDlsgSettings.bind(dlsgSettingsApi),
        baseUrl,
        'getDlsgSettings',
        currentProjectId
      ),
    saveDlsgSettings: (dlsgSettings: DlsgSettings) =>
      dlsgSettingsApi.saveDlsgSettings(currentProjectId, dlsgSettings),
  };
};
